import {CSSProperties} from '@vanilla-extract/css';

import {theme} from '#theme/theme.css';

const textVariantStyles = {
  heading1: {
    small: {
      fontFamily: theme.fonts.generator,
      fontSize: theme.fontSizes[52],
      fontWeight: theme.fontWeights.light,
      letterSpacing: '-0.01em',
      lineHeight: theme.lineHeights[60],
    },
    medium: {
      fontFamily: theme.fonts.generator,
      fontSize: theme.fontSizes[60],
      fontWeight: theme.fontWeights.light,
      letterSpacing: '-0.01em',
      lineHeight: theme.lineHeights[68],
    },
    large: {
      fontFamily: theme.fonts.generator,
      fontSize: theme.fontSizes[68],
      fontWeight: theme.fontWeights.light,
      letterSpacing: '-0.01em',
      lineHeight: theme.lineHeights[74],
    },
  },
  heading2: {
    small: {
      fontFamily: theme.fonts.generator,
      fontSize: theme.fontSizes[32],
      fontWeight: theme.fontWeights.regular,
      letterSpacing: '-0.01em',
      lineHeight: theme.lineHeights[40],
    },
    medium: {
      fontFamily: theme.fonts.generator,
      fontSize: theme.fontSizes[40],
      fontWeight: theme.fontWeights.regular,
      letterSpacing: '-0.01em',
      lineHeight: theme.lineHeights[48],
    },
    large: {
      fontFamily: theme.fonts.generator,
      fontSize: theme.fontSizes[48],
      fontWeight: theme.fontWeights.regular,
      letterSpacing: '-0.01em',
      lineHeight: theme.lineHeights[56],
    },
  },
  heading3: {
    small: {
      fontFamily: theme.fonts.generator,
      fontSize: theme.fontSizes[20],
      fontWeight: theme.fontWeights.regular,
      letterSpacing: '-0.01em',
      lineHeight: theme.lineHeights[28],
    },
    medium: {
      fontFamily: theme.fonts.generator,
      fontSize: theme.fontSizes[24],
      fontWeight: theme.fontWeights.regular,
      letterSpacing: '-0.01em',
      lineHeight: theme.lineHeights[32],
    },
    large: {
      fontFamily: theme.fonts.generator,
      fontSize: theme.fontSizes[28],
      fontWeight: theme.fontWeights.regular,
      letterSpacing: '-0.01em',
      lineHeight: theme.lineHeights[36],
    },
  },
  heading4: {
    small: {
      fontFamily: theme.fonts.generator,
      fontSize: theme.fontSizes[18],
      fontWeight: theme.fontWeights.semiBold,
      letterSpacing: '-0.01em',
      lineHeight: theme.lineHeights[24],
    },
  },
  body: {
    small: {
      fontFamily: theme.fonts.generator,
      fontSize: theme.fontSizes[16],
      letterSpacing: '-0.01em',
      lineHeight: theme.lineHeights[24],
    },
    medium: {
      fontFamily: theme.fonts.generator,
      fontSize: theme.fontSizes[18],
      letterSpacing: '-0.01em',
      lineHeight: theme.lineHeights[28],
    },
    large: {
      fontFamily: theme.fonts.generator,
      fontSize: theme.fontSizes[20],
      letterSpacing: '-0.01em',
      lineHeight: theme.lineHeights[32],
    },
  },
  bodyLarge: {
    small: {
      fontFamily: theme.fonts.generator,
      fontSize: theme.fontSizes[20],
      letterSpacing: '-0.01em',
      lineHeight: theme.lineHeights[28],
    },
    medium: {
      fontFamily: theme.fonts.generator,
      fontSize: theme.fontSizes[22],
      letterSpacing: '-0.01em',
      lineHeight: theme.lineHeights[32],
    },
    large: {
      fontFamily: theme.fonts.generator,
      fontSize: theme.fontSizes[24],
      letterSpacing: '-0.01em',
      lineHeight: theme.lineHeights[36],
    },
  },
  bodyXLarge: {
    small: {
      fontFamily: theme.fonts.generator,
      fontSize: theme.fontSizes[24],
      letterSpacing: '-0.01em',
      lineHeight: theme.lineHeights[36],
    },
    medium: {
      fontFamily: theme.fonts.generator,
      fontSize: theme.fontSizes[28],
      letterSpacing: '-0.01em',
      lineHeight: theme.lineHeights[40],
    },
    large: {
      fontFamily: theme.fonts.generator,
      fontSize: theme.fontSizes[32],
      letterSpacing: '-0.01em',
      lineHeight: theme.lineHeights[44],
    },
  },
  button: {
    small: {
      fontFamily: theme.fonts.generator,
      fontSize: theme.fontSizes[18],
      fontWeight: theme.fontWeights.semiBold,
      letterSpacing: '0.01em',
      lineHeight: theme.lineHeights[24],
    },
  },
  buttonSmall: {
    small: {
      fontFamily: theme.fonts.generator,
      fontSize: theme.fontSizes[16],
      fontWeight: theme.fontWeights.semiBold,
      letterSpacing: '0.01em',
      lineHeight: theme.lineHeights[18],
    },
  },
  caption: {
    small: {
      fontFamily: theme.fonts.generator,
      fontSize: theme.fontSizes[14],
      fontWeight: theme.fontWeights.medium,
      letterSpacing: '0.01em',
      lineHeight: theme.lineHeights[16],
    },
  },
  label: {
    small: {
      fontFamily: theme.fonts.faktum,
      fontSize: theme.fontSizes[14],
      fontWeight: theme.fontWeights.semiBold,
      letterSpacing: 0,
      lineHeight: theme.lineHeights[16],
      textTransform: 'uppercase',
    },
  },
};

export const text = textVariantStyles as Record<
  keyof typeof textVariantStyles,
  {small: CSSProperties; medium?: CSSProperties; large?: CSSProperties}
>;
